import useEbookStore from 'features/ebook/store';
import { DATA_CY_EBOOK_CARD_COMPONENT } from 'features/ebook/__tests__/constant';
import { AWS_EBOOK_BUCKET } from '../../../../constants/api';
import { SCard, SCardImg, SCardTitle } from '../styled';

const Card = ({
  imageName,
  bookName,
  alias,
  isPaneActive,
}: {
  imageName: string;
  bookName: string;
  alias: string;
  isPaneActive: boolean;
}) => {
  const { getEbookDetail } = useEbookStore();

  const cardClickHandler = (urlName: string): void => {
    getEbookDetail(urlName);
  };

  return (
    <SCard
      data-cy={DATA_CY_EBOOK_CARD_COMPONENT}
      onClick={() => cardClickHandler(alias)}
      // @ts-expect-error
      isPaneActive={isPaneActive}
    >
      <SCardImg
        src={`${AWS_EBOOK_BUCKET}/${imageName}`}
        isPaneActive={isPaneActive}
      />
      <SCardTitle>{bookName}</SCardTitle>
    </SCard>
  );
};

export default Card;
